<template>
    <div class="md-layout">
        <label class="md-layout-item md-size-20 md-form-label top_pad_none">
            {{amenity.name}}
        </label>
        <div class="md-layout-item">
            <md-checkbox v-for="option in amenity.details.options" v-model="amenity.details.model" :key="option" :value="option">{{option}}</md-checkbox>
        </div>
    </div>
</template>
<script>
    export default {
        name: "AmenityCheckbox",
        props: {
            amenity: null
        }
    };
</script>
<style>
   
</style>
